export const privacyPolicyData = [
  {
    id: 1,
    title: "Privacy Policy",
    text: `At ***Expedient Staffing Solutions, Inc*** we take your privacy seriously. This Privacy Statement explains how we collect, use, and protect your personal information as part of our recruitment and job placement services, including communications via phone, email, and SMS.`,
  },
  {
    id: 2,
    title: "Information We Collect",
    text: `As part of our employment services, we may collect the following information:
  
  - Contact information (name, phone number, email address, address)  
  - Employment history and resume details  
  - Social Security Number and other identification  
  - Job preferences and availability  
  - References and background check information  
  - SMS communication preference`,
  },
  {
    id: 3,
    title: "How We Use Your Information",
    text: `We use your personal data to:

  - Match you with suitable job opportunities  
  - Communicate regarding applications, interviews, or placements  
  - Conduct background checks (with your consent)  
  - Verify identity and employment eligibility  
  - Comply with legal and contractual obligations  
  
  We may also use your phone number to send job alerts or application updates via ***SMS***. You can opt out of SMS messages at any time by replying ***STOP***. For assistance, reply ***HELP*** or contact us at Info@exp-staffing.com.`,
  },
  {
    id: 4,
    title: "Sharing of Information",
    text: `We may share your information with:
  
  - Employers or clients seeking candidates for open positions  
  - Background screening providers (with your consent)  
  - Payroll and onboarding service providers (if hired)  
  - Legal or regulatory bodies as required by law  
  
  We ***do not sell*** or rent your personal information to third parties for marketing purposes.`,
  },
  {
    id: 5,
    title: "Data Security",
    text: `We maintain administrative, technical, and physical safeguards to protect your information from unauthorized access or disclosure. Access to sensitive data (such as SSNs) is strictly limited to authorized personnel.`,
  },
  {
    id: 6,
    title: "Your Privacy Rights",
    text: `You have the right to access, update, or request deletion of your personal data, subject to applicable laws. To make a request, please email us at ***Info@exp-staffing.com***.
  
  If you're located in California, the European Union, or other jurisdictions with enhanced privacy laws, additional rights may apply under ***CCPA***, ***GDPR***, or local laws.`,
  },
  {
    id: 7,
    title: "Contact Us",
    text: `If you have questions about how your data is handled or would like to exercise your privacy rights, please contact:
  
  **Expedient Staffing Solutions, Inc**  
  Staten Island, NY 10309  
  Email: Info@exp-staffing.com  
  Phone: 646-580-8420`,
  },
];
